<template>
  <div>
    <div class="space-between align-center">
      <div class="align-center flex-1">
        <div class="filter-icon">
          <img src="/img/filter.svg" alt="" />
        </div>

        <div class="search-wrappper">
          <b-input-group size="sm">
            <b-form-input v-model="filter" placeholder="Search here...">
            </b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>

      <button
        type="button"
        class="btn mulai btn-secondary font-bold"
        @click="handleNew"
      >
        <fa-icon icon="edit" class="my-icon" />&nbsp; ADD NEW NOTIFICATION
      </button>
    </div>
    <br />
    <br />
    <!-- Main table element -->
    <b-table
      show-empty
      stacked="md"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template #cell(title)="row">
        <ul>
          <li v-for="(item, idx) in row.item.title">
            {{ idx }} : {{ item }}
          </li>
        </ul>
      </template>

      <template #cell(content)="row">
        <ul>
          <li v-for="(item, idx) in row.item.content">
            {{ idx }} : {{ item }}
          </li>
        </ul>
      </template>

      <template #cell(actions)="row">
        <b-button
          size="sm"
          class="mr-3 action-button"
          variant="outline-secondary"
          @click="handleSend(row.item.id)"
        >
          <fa-icon icon="play-circle" class="my-icon" />&nbsp;Re-Send
        </b-button>
      </template>
    </b-table>

    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <b-modal
      v-model="addModal"
      id="addModal"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <modal-cross @close="addModal = false"></modal-cross>
      <div class="p-4">
        <h3 class="txt-center color2">Add New Notification</h3>
        <br />

        <label>Type</label>
        <br />
        <b-form-input
          placeholder="Type"
          v-model="inputData.type"
        ></b-form-input>
        <br /><br />

        <label>Title</label>
        <br />
        <span>English (EN)</span>
        <br />
        <b-form-input
          placeholder="Title"
          v-model="inputData.title.en"
        ></b-form-input>
        <br />
        <span>Indonesia (ID)</span>
        <br />
        <b-form-input
          placeholder="Title"
          v-model="inputData.title.id"
        ></b-form-input>
        <br /><br />

        <label>Content</label>
        <br />
        <span>English (EN)</span>
        <br />
        <b-form-input
          placeholder="Content"
          v-model="inputData.content.en"
        ></b-form-input>
        <br />
        <span>Indonesia (ID)</span>
        <br />
        <b-form-input
          placeholder="Content"
          v-model="inputData.content.id"
        ></b-form-input>
        <br /><br />

        <label>App URL</label>
        <br />
        <b-form-input
          placeholder="App URL"
          v-model="inputData.app_url"
        ></b-form-input>
        <br /><br />

        <label>Web URL</label>
        <br />
        <b-form-input
          placeholder="Web URL"
          v-model="inputData.web_url"
        ></b-form-input>
        <br /><br />

        <div class="justify-end">
          <my-button
            type="blue"
            disabled
            v-show="showLoading"
          >
            <b-spinner small></b-spinner>
            <span class="sr-only">Loading...</span>
          </my-button>
          <my-button
            type="blue"
            v-show="!showLoading"
            @click="handleSave"
          >
            SEND & SAVE
          </my-button>
        </div>
        <br />
      </div>
    </b-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      editData: false,
      isBusy: false,
      items: [],
      fields: [
        {
          key: "id",
          label: "#ID"
        },
        {
          key: "type",
          label: "Type"
        },
        {
          key: "title",
          label: "Title"
        },
        {
          key: "content",
          label: "Content"
        },
        {
          key: "actions",
          label: "Action"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      addModal: false,
      inputData: {
        type: "",
        title: {
          id: "", 
          en: ""
        },
        content: {
          id: "", 
          en: ""
        },
        web_url: "", 
        app_url: ""
      },
      showLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn"
    })
  },
  created() {
    if (!this.isLoggedIn) {
      this.$router.push("/login");
    }
  },

  mounted() {
    this.totalRows = this.items.length;
    this.notifList();
  },

  methods: {
    ...mapActions({
      getNotifList: types.GET_NOTIF_LIST,
      createNotif: types.CREATE_NOTIF, 
      sendNotif: types.SEND_NOTIF
    }),
    handleNew() {
      this.addModal = true;
    },
    notifList() {
      this.isBusy = true;
      this.getNotifList()
        .then(response => {
          var res = response;
          this.items = [];
          for (var i = 0; i < res.length; i++) {
            var dataItem = {
              id: res[i].id,
              type: res[i].type,
              title: res[i].title,
              content: res[i].content,
              web_url: res[i].web_url, 
              app_url: res[i].app_url,
              created_at: res[i].created_at,
            };
            this.items.push(dataItem);
          }
          this.totalRows = res.length;
          this.isBusy = false;
        })
        .catch(error => {
          this.showMessageBox(error, "Failed", "success");
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleSend(id) {
      this.$bvModal.msgBoxConfirm('Re-send this notification?', {
        title: 'Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value) {
            this.sendNotif({id:id})
            .then(response => {
              this.showMessageBox("Sent", "Success", "success");
            })
            .catch(error => {
              this.showMessageBox(error, "Failed", "success");
            });
          }
        })
        .catch(err => {
          this.showMessageBox(err, "Failed", "success");
        });
    },
    handleSave() {
      if(this.inputData.content.id || this.inputData.content.en) {
        this.showLoading = true;

        var content = {}
        var title = {}
        var titleFlag = false
        if(this.inputData.content.id) {
          content.id = this.inputData.content.id
          if(this.inputData.title.id) {
            titleFlag = true
            title.id = this.inputData.title.id
          }
        }
        if(this.inputData.content.en) {
          content.en = this.inputData.content.en
          if(this.inputData.title.en) {
            titleFlag = true
            title.en = this.inputData.title.en
          }
        }

        var payload = {
          content: content
        }
        if(titleFlag) {
          payload.title = title
        }
        if(this.inputData.type) {
          payload.type = this.inputData.type
        }
        if(this.inputData.web_url) {
          payload.web_url = this.inputData.web_url
        }
        if(this.inputData.app_url) {
          payload.app_url = this.inputData.app_url
        }

        this.createNotif(payload)
        .then(response => {
          // eslint-disable-next-line
          var res = response;
          this.addModal = false;
          this.showLoading = false;
          this.notifList();
          this.showMessageBox("Notification has been sent", "Success", "success");
        })
        .catch(error => {
          this.showLoading = false;
          this.showMessageBox(error, "Failed", "success");
        });
      } else {
        this.showMessageBox("Please fill notification content", "Data Not Complete", "success");
      }
    },
    showMessageBox(message, title, variant) {
      this.$bvModal
      .msgBoxOk(message, {
        title: title,
        size: "sm",
        buttonSize: "sm",
        okVariant: variant,
        centered: true
      })
      .then(value => {
      })
      .catch(err => {
      });
    }
  }
};
</script>

<style>
.search-wrapper {
  width: 100%;
  max-width: 222px;
}

.filter-icon {
  margin-right: 11px;
  background-color: #e9e9e9;
  width: 32px;
  height: 32px;
  border-radius: 32px;
  text-align: center;
  padding-top: 7px;
}

.action-button:hover {
  background-color: #f08045;
  border: 1px solid #f08045;
}
</style>